module.exports = __webpack_public_path__ + "04_glasses_red.f40ad8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/04_glasses_red.png
// module id = xGnJ
// module chunks = 0